<template>
  <div class="btn-logo">
    <IconByTheNumbers width="45" height="45" class="btn-logo__icon" />
    <h1 class="btn-logo__text">By the Numbers</h1>
  </div>
</template>

<script>
  import IconByTheNumbers from '~/components/icon/IconByTheNumbers.vue';

  export default {
    name: 'ByTheNumbersLogo',
    components: { IconByTheNumbers },
  };
</script>

<style lang="scss" scoped>
  .btn-logo {
    display: flex;
    align-items: flex-end;
    gap: 16px;
    padding: 0 0 32px 0;

    &__text {
      font-size: 38px;
      font-weight: 600;
      margin: 0;
      padding: 0;
      margin-bottom: -10px;
    }
  }
</style>
